module.exports = __webpack_public_path__ + "static/img/Greg-Bird.2b1b6ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Greg-Bird.jpg
// module id = AjrW
// module chunks = 0